import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import ForbiddenStateImage from '../../assets/forbiddenstate.svg';

const ChangeEventForbiddenState = () => {
  return /* @__PURE__ */ React.createElement(Grid, { container: true, justifyContent: "center", direction: "column", alignItems: "center" }, /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(Typography, { variant: "h5" }, "Feature not available with your account or token.")), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(
    "img",
    {
      src: ForbiddenStateImage,
      alt: "ForbiddenState",
      "data-testid": "forbiddenStateImg"
    }
  )));
};

export { ChangeEventForbiddenState };
//# sourceMappingURL=ChangeEventForbiddenState.esm.js.map
